import type { QuoteData, QuoteResponse } from '@/types/quote.types';
import { executeForCRUD, type IRequestParams } from '../frontBack';
import { getAgentId } from '@/config/api';
import { firstTruthy } from './catalogMappers';

const buildQuoteParams = (quoteData: QuoteData): IRequestParams => {
  const params: IRequestParams = {
    ClassName: 'VC_Cotizaciones',
    Action: 'Insert',
    Year: quoteData.year,
    Id_Marca: quoteData.brand?.id,
    Id_Modelo: quoteData.model?.id,
    Id_Version: quoteData.version?.id,
    Genero: quoteData.personalData?.gender,
    CodigoPostal: quoteData.personalData?.postalCode,
    FechaNacimiento: quoteData.personalData?.birthDate,
    Email: quoteData.personalData?.email,
    UsuarioAdd: 1,
    GetDataModel: 'false',
    GetDataTable: 'false',
  };
  const agentId = getAgentId();
  if (agentId) {
    params.AgentId = agentId;
  }
  return params;
};

const mapQuoteRow = (quote: Record<string, unknown>): QuoteResponse => {
  const coverage = firstTruthy(quote, ['Coberturas', 'coverage'], undefined);
  return {
    id: String(firstTruthy(quote, ['Id', 'id'], '')),
    price: Number(firstTruthy(quote, ['Precio', 'price'], 0)),
    currency: String(firstTruthy(quote, ['Moneda', 'currency'], 'MXN')),
    coverage: Array.isArray(coverage) ? (coverage as string[]) : [],
    validUntil: String(firstTruthy(quote, ['ValidoHasta', 'validUntil'], '')),
  };
};

export const getQuote = async (quoteData: QuoteData): Promise<QuoteResponse> => {
  const response = await executeForCRUD(buildQuoteParams(quoteData));
  if (response.success && Array.isArray(response.data) && response.data.length > 0) {
    return mapQuoteRow(response.data[0] as Record<string, unknown>);
  }
  throw new Error(response.errorMessage || 'Error al obtener la cotización');
};
